const VIDEO_JS_DEFAULTS = {
    'controls': true,
    'autoplay': true,
    'preload': 'auto',
    'poster': '',
    'loop': false,

    // Default order of fallback technology
    'techOrder': ['html5', 'hlsjs'],

    'html5': {},

    'flash': { 'swf': 'http://z.cdn.turner.com/adultswim/tools/lib/video-js/video-js.swf' },

    // Default of web browser is 300x150. Should rely on source width/height.
    'width': '100%',
    'height': 0,
    // defaultVolume: 0.85, // doesn't seem to do anything

    // default playback rates
    'playbackRates': [],

    // default inactivity timeout
    'inactivityTimeout': 500,

    // Included control sets
    'children': {
        'mediaLoader': {},
        'posterImage': {},
        'loadingSpinner': {},
        'textTrackDisplay': {},
        'bigPlayButton': {},
        'controlBar': {
            'playToggle': {},
            'currentTimeDisplay': {},
            'timeDivider': false,
            'customControlSpacer': false,
            'durationDisplay': false,
            'remainingTimeDisplay': false,
            'liveDisplay': false,
            'progressControl': {},
            'fullscreenToggle': {},
            'volumeControl': false,
            'muteToggle': {},
            'volumeMenuButton': false,
            'playbackRateMenuButton': false,
            'subtitlesButton': false,
            'captionsButton': {},
            'chaptersButton': false
          },
        'errorDisplay': {},
        'textTrackSettings': {}
    },

    'language': document.getElementsByTagName('html')[0].getAttribute('lang') || navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language || 'en',

    // locales and their language translations
    'languages': {},

    // Default message to show when a video cannot be played.
    'notSupportedMessage': 'No compatible source was found for this video.'
};

export default VIDEO_JS_DEFAULTS;


// WEBPACK FOOTER //
// ./src/config/video-js-defaults.js